import React from 'react';
import { Link } from 'react-router-dom';

const Ghee = () => {
  return (
    <div>
      <div className="bg-gray-100 py-4">
        <div className="container mx-auto px-4">
          <div className="text-sm text-gray-600">
            <Link to="/" className="hover:text-accent">Home</Link> / 
            <Link to="/projects" className="hover:text-accent"> Projects</Link> / 
            <span className="text-gray-900"> Ghee Processing Plant</span>
          </div>
        </div>
      </div>

      <section className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">Ghee Processing Plant</h1>
          <p className="text-xl text-gray-300">Agmark Standard Compliant Ghee Production</p>
        </div>
      </section>

      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-5xl">
          <p className="text-lg text-gray-700 mb-6">
            ATHENA offers highly efficient ghee plants which helps in extraction of Ghee. The process involves melting of butter or cream, separation, clarification, filtration, cooling and then its packing. We offer Ghee processing plant of various capacities as per client requirement.
          </p>

          <h2 className="text-3xl font-bold mb-6 section-title">Process Description</h2>
          <p className="text-gray-700 mb-6">
            Butter from the melting vat is pumped to the ghee boiler where it is heated to about 107°C gently so as to evaporate water from the molten butter and is then allowed to remain undisturbed for about half an hour. From the bottom of the ghee boiler the ghee is taken out into ghee settling tanks where ghee is allowed to settle for a few hours, so as to remove maximum ghee residue from the ghee. The decanted ghee is further pumped through a ghee clarifier so as to remove the fine particles of ghee residue from the ghee and clarified ghee is stored in ghee storage tank where it is further cooled to desired temperature (28-30°C) suitable for ghee filling.
          </p>

          <h3 className="text-2xl font-bold mb-4 text-accent">Packing of Ghee</h3>
          <p className="text-gray-700 mb-6">
            The ghee from the storage tank is analyzed from different tests by the quality control staff and if the quality of ghee conforms to Agmark standard, the ghee is filled into tins of different sizes as per market demand and stored into a cold room, so as to get the desired texture of ghee for period of 48 hours at about 15°C. The ghee from the cold room is taken out after 48 hours and stored in the ghee warehouse for further dispatch to the market.
          </p>
        </div>
      </section>

      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-3xl font-bold mb-8 section-title">Chemical Composition of Ghee</h2>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr>
                  <th className="text-left">Parameter</th>
                  <th className="text-left">Cow</th>
                  <th className="text-left">Buffalo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Milk Fat</td>
                  <td colSpan="2">99 to 99.5%</td>
                </tr>
                <tr>
                  <td>Moisture</td>
                  <td colSpan="2">Not more than 0.5%</td>
                </tr>
                <tr>
                  <td>Unsaponiable matter</td>
                  <td>3.2-7.4</td>
                  <td>17-38</td>
                </tr>
                <tr>
                  <td>Carotene (µg/g)</td>
                  <td>19-34</td>
                  <td>18-37</td>
                </tr>
                <tr>
                  <td>Vit A (I.U/g)</td>
                  <td colSpan="2">26-48</td>
                </tr>
                <tr>
                  <td>Free fatty acid (% oleic)</td>
                  <td colSpan="2">Max 2.8 (Agmark)</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="py-16 bg-black text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Start Your Ghee Production Plant</h2>
          <Link to="/contact" className="btn-primary px-8 py-3 rounded-lg font-semibold inline-block">
            Get a Quote
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Ghee;